import { COMMON, STORY, ifyouApi } from 'apis/config';
/**
 * * 작품 관리 - 능력치 api & 오토메 프로필 api
 */

export const abilityApi = {
  read: (projectId) =>
    ifyouApi.get(`${STORY}/${projectId}/ability-list`).then((res) => res.data),
  detail: (projectId, abilityId) =>
    ifyouApi
      .post(`${STORY}/${projectId}/ability-detail`, { ability_id: abilityId })
      .then((res) => res.data),
  abilityRegister: (projectId, inputData, langData) =>
    ifyouApi
      .post(`${STORY}/${projectId}/ability-register`, {
        speaker: inputData.speaker,
        min_value: Number(inputData.min_value),
        max_value: Number(inputData.max_value),
        is_main: inputData.is_main,
        icon_design_id: inputData.icon_design_id,
        standing_id: inputData.standing_id,
        emoticon_image_id: inputData.emoticon_image_id,
        langList: langData,
      })
      .then((res) => res.data),
  characterRegister: ({ projectId, speaker }) =>
    ifyouApi
      .post(`${STORY}/${projectId}/character-register`, {
        speaker: speaker,
      })
      .then((res) => res.data),
  abilityUpdate: ({ projectId, abilityId, detailData, langList }) => {
    return ifyouApi
      .post(`${STORY}/${projectId}/ability-update`, {
        ability_id: Number(abilityId),
        min_value: Number(detailData.min_value),
        max_value: Number(detailData.max_value),
        is_main: detailData.is_main,
        icon_design_id: detailData.icon_design_id,
        standing_id: detailData.standing_id,
        emoticon_image_id: detailData.emoticon_image_id,
        langList: langList,
      })
      .then((res) => res.data);
  },
  characterUpdate: ({ projectId, originName, newSpeaker }) =>
    ifyouApi
      .post(`${STORY}/${projectId}/character-update`, {
        origin_speaker: originName,
        new_speaker: newSpeaker,
      })
      .then((res) => res.data),
  characterDelete: ({ projectId, speaker }) =>
    ifyouApi
      .post(`${STORY}/${projectId}/character-delete`, {
        speaker: speaker,
      })
      .then((res) => res.data),
  abilityDelete: (projectId, abilityId) =>
    ifyouApi
      .post(`${STORY}/${projectId}/ability-delete`, {
        ability_id: abilityId,
      })
      .then((res) => res.data),
};

//** 오토메에서만 쓰일 때 */
export const profileApi = {
  detail: (projectId, abilityId) =>
    ifyouApi
      .post(`${STORY}/${projectId}/otome-ability-detail`, {
        ability_id: abilityId,
      })
      .then((res) => res.data),
  update: ({ projectId, abilityId, detailData, lineList }) =>
    ifyouApi
      .post(`${STORY}/${projectId}/otome-ability-update`, {
        ability_id: Number(abilityId),
        ability_name: detailData.ability_name,
        min_value: detailData.min_value,
        max_value: detailData.max_value,
        is_main: detailData.is_main,
        icon_design_id: detailData.icon_design_id,
        standing_id: detailData.standing_id,
        emoticon_image_id: detailData.emoticon_image_id,
        local_id: detailData.local_id,
        profile_height: detailData.profile_height,
        profile_age: detailData.profile_age,
        profile_birth_date: detailData.profile_birth_date,
        profile_favorite_id: detailData.profile_favorite_id,
        profile_hate_id: detailData.profile_hate_id,
        profile_line_id: detailData.profile_line_id,
        profile_introduce_id: detailData.profile_introduce_id,
        line_list: lineList,
      })
      .then((res) => res.data),
};

//** 능력치 부분 드롭다운 데이터 모음 */
export const fetchDropAbilityList = {
  // 능력치 - 캐릭터 이름 드롭다운 (네임태그 리스트의 이름을 가져온다)
  character: (projectId) =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'dropdownNametag',
        project_id: projectId,
      })
      .then((res) => res.data),
  icon: (projectId) =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'getAbilityList',
        code: 'ability_icon',
        project_id: projectId,
      })
      .then((res) => res.data),
  emoticon: (projectId, characterName) =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'dropdownEmoticon',
        project_id: projectId,
        character_name: characterName,
      })
      .then((res) => res.data),
  standing: (projectId) =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'getAbilityList',
        code: 'ability_standing',
        project_id: projectId,
      })
      .then((res) => res.data),
  motion: (projectId, speaker) =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'dropdownMotion',
        // project_id: '57',
        project_id: Number(projectId),
        speaker: speaker,
      })
      .then((res) => res.data),
};
